<template>
    <div>
        <div class="card mb-4 border-0">
            <div class="card-body">
              <div class="row" v-if="select || result == 1">
                <div class="col-12">
                  <third-screen :data="select" :result="result" @close="select = null"></third-screen>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-12">
                  <!-- <perfect-scrollbar> -->
                    <v-app>
                      <div class="table-responsive">
                        <v-data-table class="elevation-0"
                            :headers="headers"
                            :items="sortedItems"
                            :item-class="(item) => { return (select ? item.IdUsuario == select.IdUsuario ? 'bg-light' : '' : '')}"
                            dense
                            :items-per-page="10">
                            <template v-slot:[`item.Guias`]="{ item }">
                              <p class="my-2"><b>{{ onGroup(item.InfoTrackingPaquete, function (x) { return x.Guia }).length }}</b></p>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                              <button type="button" @click="onSelect(item)" class="btn btn-primary my-2 rounded-circle" style="width: 30px !important; height: 30px !important; display: flex !important; justify-content: center !important; align-items: center !important;"><i class="bi bi-arrow-right-short"></i></button>
                            </template>
                        </v-data-table>
                      </div>
                    </v-app>
                  <!-- </perfect-scrollbar> -->
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import search from '@/assets/icons/search.svg'
import moment from 'moment-timezone'
import timezones from '@/assets/json/timezones.json'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    headers: [
      { text: 'Nombre', value: 'Nombre' },
      { text: 'Direccion', value: 'Direccion' },
      { text: 'Pais', value: 'Pais' },
      { text: 'Guias', value: 'Guias' },
      { text: 'Acción', value: 'action' }
    ],
    select: null,
    result: 0,
    search,
    timezones
  }),
  computed: {
    sortedItems: function () {
      this.data.forEach(element => {
        element.Fecha = this.onFormat(String(element.Fecha), element.Pais)
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.data.sort((a, b) => { return new Date(b.Fecha) - new Date(a.Fecha) })
    }
  },
  methods: {
    onGroup: function (data, lambda) {
      return data.reduce(function (groups, current) {
        var val = lambda(current)
        var index = groups.findIndex(function (x) {
          return x.key === val
        })
        if (index < 0) {
          index = groups.push({
            key: val,
            items: []
          }) - 1
        }
        groups[index].items.push(current)
        return groups
      }, [])
    },
    onSelect: function (item) {
      this.select = item
      this.result = 1
      setTimeout(() => {
        this.result = 0
      }, 1000)
    },
    onFormat: function (date, country) {
      let c = timezones.find((e) => e.name === country.replace(' (the)', ''))
      if (c.name === 'United States of America') {
        c.name = 'New York'
      }
      var gt = moment.tz(String(date), 'DD/MM/YYYY hh:mm:ss', c.region + '/' + c.name.replace(/\s/g, '_'))
      var guatemala = gt.clone().tz('America/Guatemala')
      return guatemala.format('YYYY/MM/DD hh:mm A')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company/components/Table.vue